import { useSelector } from 'react-redux';
export function useIsVisitorMode() {
    // this is done this way to allow Dumbo blurring in visitor mode on profiles
    // we told product that it's a hack and will be a brittle implementation as we move forward
    return useSelector(function (state) { var _a; return !!((_a = state === null || state === void 0 ? void 0 : state.profileOwner) === null || _a === void 0 ? void 0 : _a.isViewingAsVisitor); });
}
//# sourceMappingURL=useIsVisitorMode.js.map